export const OtpModalConstant = {
    //modal button values
    VALIDATE_OTP: 'VALIDATE',
    VALIDATING_OTP: 'VALIDATING OTP...'
}